var _path, _path2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCopyNew = function SvgCopyNew(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9959 9.58734H11.6209C10.4703 9.58734 9.53754 10.5201 9.53754 11.6707V21.0457C9.53754 22.1963 10.4703 23.129 11.6209 23.129H20.9959C22.1465 23.129 23.0792 22.1963 23.0792 21.0457V11.6707C23.0792 10.5201 22.1465 9.58734 20.9959 9.58734Z",
    stroke: "white",
    strokeWidth: 1.90087,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.37087 15.8373H4.3292C3.1786 15.8373 2.24586 14.9046 2.24586 13.754V4.379C2.24586 3.22841 3.1786 2.29567 4.3292 2.29567H13.7042C14.8548 2.29567 15.7875 3.22841 15.7875 4.379V5.42067",
    stroke: "white",
    strokeWidth: 1.90087,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopyNew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copy-new.b0f82fdf.svg";
export { ForwardRef as ReactComponent };